import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { YearlyChartComponent } from './visual-data-components/yearly-chart/yearly-chart.component';
import {
  ReturnOnInvestmentChartComponent,
} from './visual-data-components/return-on-investment-chart/return-on-investment-chart.component';
import { MonthlyChartComponent } from './visual-data-components/monthly-chart/monthly-chart.component';
import { CustomerRoutingModule } from '../../../app/customer/customer-routing.module';
import { SharedModule } from '../../shared.module';
import { NgChartsModule } from 'ng2-charts';
import { SolarAssessmentComponent } from './value-components/solar-assessment/solar-assessment.component';
import { YearlySavingsComponent } from './value-components/yearly-savings/yearly-savings.component';
import { UserInvestmentComponent } from './value-components/user-investment/user-investment.component';
import {
  AdvancedSolarCalculationResultComponent,
} from './advanced-solar-calculation-result/advanced-solar-calculation-result.component';
import {
  BasicSolarCalculationResultComponent,
} from './basic-solar-calculation-result/basic-solar-calculation-result.component';
import { AnnotationsComponent } from './annotations/annotations.component';
import { MonthlyValuesComponent } from './value-components/monthly-values/monthly-values.component';
import { AnalysisTableComponent } from './visual-data-components/analysis-table/analysis-table.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@ngneat/transloco';
import { AnnualHourlyChartComponent } from './visual-data-components/annual-hourly-chart/annual-hourly-chart.component';
import { RecalculateComponent } from './recalculate/recalculate.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HourlyToolResultComponent } from './advanced-results/hourly-tool-result/hourly-tool-result.component';
import { MonthlyResultsWrapperComponent } from './monthly-results-wrapper/monthly-results-wrapper.component';
import { HourlyManualResultComponent } from './advanced-results/hourly-manual-result/hourly-manual-result.component';
import { MonthlyManualResultComponent } from './advanced-results/monthly-manual-result/monthly-manual-result.component';
import { MonthSelectorComponent } from './common/month-selector/month-selector.component';
import { PdfDownloadComponent } from './pdf-download/pdf-download.component';
import { SavePowerPlantComponent } from './save-power-plant/save-power-plant.component';
import { PdfConclusionService } from './pdf-download/pdf-conclusion.service';
import { PayForFullComponent } from './pay-for-full/pay-for-full.component';
import { SavePowerPlantFormComponent } from './save-power-plant-form/save-power-plant-form.component';
import { UserHasRolePipe } from '../../pipes/user-has-role.pipe';
import { PeakPowerChartComponent } from './visual-data-components/peak-power-chart/peak-power-chart.component';
import {
  SimpleSolarCalculationResultComponent,
} from './simple-solar-calculation-result/simple-solar-calculation-result.component';
import {
  YearlyConsumptionProjectionChartComponent,
} from './simple-result-components/yearly-consumption-projection-chart/yearly-consumption-projection-chart.component';
import { YearlySpendingComponent } from './value-components/yearly-spendings/yearly-spending.component';

@NgModule({
  providers: [
    PdfConclusionService,
    { provide: TRANSLOCO_SCOPE, useValue: { scope: 'calculator_result', alias: 'calculator_result' } },
  ],
  declarations: [
    YearlyChartComponent,
    ReturnOnInvestmentChartComponent,
    MonthlyChartComponent,
    SolarAssessmentComponent,
    YearlySavingsComponent,
    UserInvestmentComponent,
    AdvancedSolarCalculationResultComponent,
    BasicSolarCalculationResultComponent,
    AnnotationsComponent,
    MonthlyValuesComponent,
    AnalysisTableComponent,
    AnnualHourlyChartComponent,
    RecalculateComponent,
    HourlyToolResultComponent,
    MonthlyResultsWrapperComponent,
    HourlyManualResultComponent,
    MonthlyManualResultComponent,
    MonthSelectorComponent,
    PdfDownloadComponent,
    SavePowerPlantComponent,
    SimpleSolarCalculationResultComponent,
    YearlyConsumptionProjectionChartComponent,
    YearlySpendingComponent,
  ],
  imports: [
    CommonModule,
    CustomerRoutingModule,
    SharedModule,
    TranslocoModule,
    NgChartsModule,
    NgxDatatableModule,
    FormsModule,
    ReactiveFormsModule,
    PayForFullComponent,
    SavePowerPlantFormComponent,
    UserHasRolePipe,
    PeakPowerChartComponent,
  ],
  exports: [
    SolarAssessmentComponent,
    YearlySavingsComponent,
    UserInvestmentComponent,
    YearlyChartComponent,
    ReturnOnInvestmentChartComponent,
    AdvancedSolarCalculationResultComponent,
    BasicSolarCalculationResultComponent,
    AnnualHourlyChartComponent,
    SavePowerPlantComponent,
    PdfDownloadComponent,
    RecalculateComponent,
    SimpleSolarCalculationResultComponent,
  ],
})
export class SolarCalculatorResultModule {
}
